import _objectSpread from '@babel/runtime-corejs3/helpers/esm/objectSpread2';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import 'react';
import { c as classNames } from '../../shared/bind-d9144132.js';
import { ColorCode } from '../../constants/ui.js';
import { jsx } from 'react/jsx-runtime';

var styles = {
  "unit-base": "4",
  "icon": "web_ui__Icon__icon",
  "block": "web_ui__Icon__block",
  "parent": "web_ui__Icon__parent",
  "primary-default": "web_ui__Icon__primary-default",
  "primary-medium": "web_ui__Icon__primary-medium",
  "primary-extra-light": "web_ui__Icon__primary-extra-light",
  "primary-light": "web_ui__Icon__primary-light",
  "primary-dark": "web_ui__Icon__primary-dark",
  "primary-extra-dark": "web_ui__Icon__primary-extra-dark",
  "success-default": "web_ui__Icon__success-default",
  "success-medium": "web_ui__Icon__success-medium",
  "success-extra-light": "web_ui__Icon__success-extra-light",
  "success-light": "web_ui__Icon__success-light",
  "success-dark": "web_ui__Icon__success-dark",
  "success-extra-dark": "web_ui__Icon__success-extra-dark",
  "expose-default": "web_ui__Icon__expose-default",
  "expose-medium": "web_ui__Icon__expose-medium",
  "expose-extra-light": "web_ui__Icon__expose-extra-light",
  "expose-light": "web_ui__Icon__expose-light",
  "expose-dark": "web_ui__Icon__expose-dark",
  "expose-extra-dark": "web_ui__Icon__expose-extra-dark",
  "warning-default": "web_ui__Icon__warning-default",
  "warning-medium": "web_ui__Icon__warning-medium",
  "warning-extra-light": "web_ui__Icon__warning-extra-light",
  "warning-light": "web_ui__Icon__warning-light",
  "warning-dark": "web_ui__Icon__warning-dark",
  "warning-extra-dark": "web_ui__Icon__warning-extra-dark",
  "muted-default": "web_ui__Icon__muted-default",
  "amplified-default": "web_ui__Icon__amplified-default",
  "greyscale-level-1": "web_ui__Icon__greyscale-level-1",
  "greyscale-level-2": "web_ui__Icon__greyscale-level-2",
  "greyscale-level-3": "web_ui__Icon__greyscale-level-3",
  "greyscale-level-4": "web_ui__Icon__greyscale-level-4",
  "greyscale-level-5": "web_ui__Icon__greyscale-level-5",
  "greyscale-level-6": "web_ui__Icon__greyscale-level-6",
  "greyscale-level-7": "web_ui__Icon__greyscale-level-7"
};

var Display = /*#__PURE__*/function (Display) {
  Display["InlineBlock"] = "inline-block";
  Display["Block"] = "block";
  return Display;
}(Display || {});
var cssClasses = classNames.bind(styles);
var Icon = function Icon(_ref) {
  var name = _ref.name,
    _ref$display = _ref.display,
    display = _ref$display === void 0 ? Display.InlineBlock : _ref$display,
    color = _ref.color,
    title = _ref.title,
    role = _ref.role,
    aria = _ref.aria,
    testId = _ref.testId,
    tabIndex = _ref.tabIndex;
  var iconClass = cssClasses('icon', color, _defineProperty({}, display, display !== Display.InlineBlock));
  var SvgIcon = name;
  return /*#__PURE__*/jsx("span", {
    className: iconClass,
    "data-testid": testId,
    style: {
      width: SvgIcon.Size ? "".concat(SvgIcon.Size, "px") : undefined
    },
    children: /*#__PURE__*/jsx(SvgIcon, _objectSpread({
      "aria-hidden": true,
      title: title,
      role: role,
      tabIndex: tabIndex
    }, aria))
  });
};
Icon.Display = Display;
Icon.Color = ColorCode;

export { Icon as default };
//# sourceMappingURL=Icon.js.map
